import * as React from 'react';
import withThemeConfig from '../../../_utils/withThemeConfig';

var HeaderNavItem = function HeaderNavItem(props) {
  var icon = props.icon,
      title = props.title,
      url = props.url,
      onClick = props.onClick,
      themeConfig = props.themeConfig;
  var Link = themeConfig.baseComponents.Link;
  return React.createElement("li", {
    className: "HeaderNavItem"
  }, React.createElement(Link, {
    icon: icon,
    to: url,
    onClick: onClick
  }, title));
};

HeaderNavItem.defaultProps = {
  icon: undefined,
  url: undefined,
  onClick: undefined
};
HeaderNavItem.displayName = 'Header.Nav.Item';
export default withThemeConfig(HeaderNavItem);